export default {"src":"/_next/static/media/yellow_heart.daa6971e.svg","height":21,"width":23,"blurWidth":0,"blurHeight":0};